import { useContext } from 'react'

import { SidePanelHasBeenOpenedContext } from './notch-provider'

export const useSidePanelHasBeenOpenedContext = () => {
  const context = useContext(SidePanelHasBeenOpenedContext)
  if (context === undefined) {
    throw new Error(
      'useSidePanelHasBeenOpenedContext must be used within SidePanelHasBeenOpenedContextProvider',
    )
  }

  return context
}
